import React from "react";
import PropTypes from "prop-types";
import Complaint from "./Complaint.jsx";

export default class ComplaintsInformation extends React.Component {

  static propTypes = {
    claimObject: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool.isRequired,
    addPartOrLabor: PropTypes.func.isRequired,
    removePartOrLaborPrompt: PropTypes.func.isRequired,
    handleComplaintUpdate: PropTypes.func.isRequired,
    handleComplaintDelete: PropTypes.func.isRequired,
    handlePartLaborUpdate: PropTypes.func.isRequired,
    createNewComplaint: PropTypes.func.isRequired,
    onCKMSRPLoadingChange: PropTypes.func,
    showRequiredNoteError: PropTypes.bool,
    coverageDetails: PropTypes.array,
    allDataComponents: PropTypes.array,
    isAllDataComponentsLoading: PropTypes.bool,
    hasRO: PropTypes.bool,
    manuallyEnterRO: PropTypes.bool,
    errors: PropTypes.object,
    user: PropTypes.shape({
      id: PropTypes.number.isRequired,
      first_name: PropTypes.string.isRequired,
      last_name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      stores: PropTypes.arrayOf(PropTypes.string.isRequired),
      roles: PropTypes.shape({
        Map: PropTypes.object,
      }).isRequired,
      approval_limit: PropTypes.string,
    })
  };

  constructor(props) {
    super(props);
  }

  renderComplaints = (claimObject, isDisabled) => {
    if (claimObject.complaints && claimObject.complaints.length > 0) {
      return claimObject.complaints.map(this.getComplaints.bind(this, claimObject, isDisabled));
    }
  };

  getComplaints = (claimObject, isDisabled, complaint, index) => {
    let error = '';
    // if there are form errors passed from backend, pass down the relevant error to each complaint
    // object has key in the form complaint_<id>_repair_code_limit" and the value is string message
    if (this.props.errors) {
      const errorKey = `complaint_${complaint.id}_repair_code_limit`;
      if (this.props.errors[errorKey]) {
        error = this.props.errors[errorKey];
      }
    }

    return (
      <Complaint complaint={ complaint }
        claimObject={ this.props.claimObject }
        index={ index }
        isDisabled={ isDisabled }
        key={ complaint.id }
        addPartOrLabor={ this.props.addPartOrLabor.bind(this, claimObject) }
        removePartOrLabor={ this.props.removePartOrLaborPrompt.bind(this, claimObject.id) }
        handleComplaintUpdate={ this.props.handleComplaintUpdate }
        handleComplaintDelete={ this.props.handleComplaintDelete }
        handlePartLaborUpdate={ this.props.handlePartLaborUpdate }
        onCKMSRPLoadingChange={ this.props.onCKMSRPLoadingChange }
        productCode={ claimObject.product_code }
        showRequiredNoteError={ this.props.showRequiredNoteError }
        coverageList={ claimObject.coverage_list }
        coverageDetails={this.props.coverageDetails}
        allDataComponents={this.props.allDataComponents}
        isAllDataComponentsLoading={this.props.isAllDataComponentsLoading}
        user={this.props.user}
        error={error}
      />
    );
  };

  isROExist = () => {
    return (this.props.hasRO || this.props.manuallyEnterRO);
  };

  onNewComplaint = () => {
    if (!this.props.isDisabled && this.isROExist()) {
      this.props.createNewComplaint(this.props.claimObject);
    }
  };

  render() {
    const iconStyle = { color:"grey" };
    return (
      <section>
        {this.renderComplaints(this.props.claimObject, this.props.isDisabled)}
        <div className="col mt-3"
          style={ (this.props.isDisabled || !this.isROExist()) ? iconStyle : {} }
          id="add-complaint"
          onClick={ this.onNewComplaint }>
          <div className="card">
            <div className={ `card-header d-flex ${this.props.isDisabled ? "" : "cursor-pointer"}` }>
              <span>
                <i className="fa fa-plus-circle mr-2"/>
                  Add new Complaint
              </span>
            </div>
          </div>
        </div>
      </section>
    );
  }
}